import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PopupService } from './popup.service';
import { MatLegacySnackBarModule as MatSnackBarModule } from '@angular/material/legacy-snack-bar';
import { MatIconModule } from '@angular/material/icon';
import { PopupSnackbarComponent } from './popup.component';

@NgModule({
    declarations: [PopupSnackbarComponent],
    imports: [CommonModule, MatSnackBarModule, MatIconModule],
    providers: [PopupService],
})
export class PopupModule {}
